import React, { Component } from 'react';
import { Link } from 'react-router';
import { Label } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import SeverityLabel from '../../../../components/SeverityLabel/SeverityLabel';
import SmallLoader from '../../../../components/SmallLoader';
import { formatDate, formatDateTime } from '../../../../shared/utils/date';
import { I18N } from '../../../../constants';

const linkFormatter = (cell, row) => (
    <Link to={`runs/${row.runId}/abnormality/DELAY/${row.dashboardId}`}>{row.name}</Link>
);

const severityFormatter = (cell, row) =>
    row.severity ? <SeverityLabel code={row.severity} /> : '';

class DelayTable extends Component {
    render() {
        const { data, isFetching } = this.props;
        const options = {
            noDataText: isFetching ? (
                <SmallLoader />
            ) : (
                'No data to display. Please refine your search.'
            ),
        };

        return (
            <BootstrapTable data={data} striped hover options={options} pagination>
                <TableHeaderColumn isKey dataField="dashboardId" hidden>
                    ID
                </TableHeaderColumn>
                <TableHeaderColumn dataField="name" dataFormat={linkFormatter} dataSort>
                    Delay name
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="abnormalityDate"
                    dataSort
                    dataFormat={formatDateTime}
                    width={150}
                >
                    Abnormality date
                </TableHeaderColumn>
                <TableHeaderColumn dataField="routeCode" dataSort width={120}>
                    Route code
                </TableHeaderColumn>
                <TableHeaderColumn dataField="runDate" dataSort dataFormat={formatDate} width={110}>
                    Run date
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="destination"
                    dataFormat={d => <span title={d}>{d}</span>}
                    dataSort
                >
                    Destination
                </TableHeaderColumn>
                <TableHeaderColumn dataField="delay" dataSort width={100}>
                    Delay
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="severity"
                    dataFormat={severityFormatter}
                    tdStyle={{ textAlign: 'center' }}
                    width={100}
                >
                    Severity
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="abnormalityStatus"
                    dataFormat={s => I18N.ABNORMALITY_STATUS[s]}
                    dataSort
                >
                    Abn. status
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="tlmsUpdate"
                    dataFormat={value => (value ? <Label bsStyle="warning">VALIDATE</Label> : '')}
                    dataSort
                    tdStyle={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                    }}
                >
                    TLMS update
                </TableHeaderColumn>
                <TableHeaderColumn dataField="assigneeGroup" dataSort>
                    Assignee group
                </TableHeaderColumn>
                <TableHeaderColumn dataField="assignee" dataSort>
                    Assignee
                </TableHeaderColumn>
            </BootstrapTable>
        );
    }
}

export default DelayTable;
